{
  "admin": {
    "user": {
      "form": {},
      "list": {},
      "status": {},
      "mfaStatus": {}
    },
    "role": {
      "form": {},
      "list": {},
      "status": {},
      "source": {},
      "permissions": {}
    },
    "category": {
      "form": {},
      "list": {},
      "auditLevel": {},
      "permissions": {}
    },
    "permission": {
      "action": {}
    },
    "access": {
      "legend": {},
      "cellTooltip": {},
      "bulkEdit": {}
    },
    "confirm": {},
    "toast": {},
    "facility": {
      "form": {},
      "list": {},
      "type": {},
      "status": {}
    },
    "healthSystem": {
      "form": {},
      "list": {}
    },
    "location": {
      "form": {},
      "list": {},
      "type": {},
      "status": {},
      "capability": {}
    },
    "department": {
      "form": {},
      "serviceType": {},
      "status": {}
    },
    "provider": {
      "form": {},
      "list": {},
      "role": {},
      "specialty": {},
      "status": {}
    },
    "serviceLine": {
      "form": {},
      "category": {}
    },
    "clinicalService": {
      "form": {},
      "flag": {}
    },
    "serviceLocation": {
      "filter": {},
      "legend": {},
      "cellTooltip": {},
      "bulkEdit": {},
      "confirm": {}
    }
  },
  "auth": {
    "login": "Login",
    "logout": "Logout",
    "signOut": "Sign out",
    "username": "Username",
    "password": "Password",
    "forgotPassword": "Forgot Password?",
    "rememberMe": "Remember me",
    "loginButton": "Sign In",
    "loginError": "Invalid username or password",
    "sessionExpired": "Your session has expired. Please login again.",
    "signingIn": "Signing in...",
    "loginSuccess": "Login successful",
    "showPassword": "Show password",
    "hidePassword": "Hide password",
    "onboardingPrompt": "For your hospital or clinic?",
    "onboardingCta": "Request onboarding",
    "loginFailed": "Login failed",
    "developedBy": "Developed by FLOSTEL INFOTECH"
  },
  "billing": {},
  "common": {
    "appName": "VynaEMR",
    "appTagline": "APAC-First Electronic Medical Records",
    "loading": "Loading...",
    "save": "Save",
    "cancel": "Cancel",
    "delete": "Delete",
    "edit": "Edit",
    "create": "Create",
    "search": "Search",
    "filter": "Filter",
    "actions": "Actions",
    "confirm": "Confirm",
    "back": "Back",
    "next": "Next",
    "previous": "Previous",
    "submit": "Submit",
    "reset": "Reset",
    "close": "Close",
    "yes": "Yes",
    "no": "No",
    "ok": "OK",
    "error": "Error",
    "success": "Success",
    "warning": "Warning",
    "info": "Info",
    "validation": {
      "required": "This field is required",
      "invalidEmail": "Invalid email address",
      "invalidPhone": "Invalid phone number",
      "invalidDate": "Invalid date",
      "minLength": "Minimum {{min}} characters required",
      "maxLength": "Maximum {{max}} characters allowed",
      "passwordMismatch": "Passwords do not match"
    },
    "form": {
      "fieldRequired": "{{field}} is required",
      "selectOption": "Please select an option",
      "discardConfirm": "Discard unsaved changes?",
      "unsavedChanges": "You have unsaved changes"
    },
    "unsavedChanges": {
      "title": "Unsaved Changes",
      "body": "You have unsaved changes. Are you sure you want to leave this page? Your changes will be lost.",
      "stay": "Stay",
      "leave": "Leave"
    },
    "messages": {
      "saveSuccess": "Changes saved successfully",
      "saveError": "Failed to save changes",
      "deleteConfirm": "Are you sure you want to delete this item?",
      "deleteSuccess": "Item deleted successfully",
      "deleteError": "Failed to delete item",
      "networkError": "Network error. Please check your connection.",
      "serverError": "Server error. Please try again later.",
      "unauthorized": "You are not authorized to perform this action."
    },
    "dateFormat": {
      "short": "MM/DD/YYYY",
      "long": "MMMM D, YYYY",
      "withTime": "MM/DD/YYYY HH:mm",
      "timeOnly": "HH:mm"
    },
    "demo": {
      "warning": "This is the VynaEMR demo — do not enter real patient information (PHI)."
    },
    "network": {
      "offline": "You are offline. Clinical data may not be saved."
    },
    "permissionDenied": {
      "title": "Access Denied",
      "body": "You don't have permission to {{action}}.",
      "genericBody": "You don't have permission to view this resource.",
      "requiredPermission": "Required permission: {{name}}",
      "contactAdmin": "Please contact your administrator if you believe this is in error.",
      "requiresPermissionCode": "Requires permission: {{code}}",
      "requiresLabel": "Requires {{label}}",
      "requiresLabelWithRoles": "Requires {{label}} (held by: {{roles}})",
      "insufficient": "Insufficient permissions"
    },
    "skipToContent": "Skip to content",
    "openMenu": "Open menu",
    "topBar": {
      "searchPlaceholder": "Search patients (MRN, name, ID)...",
      "recentPatients": "Recent Patients",
      "searching": "Searching...",
      "noPatientsFound": "No patients found. Press Enter to search.",
      "notifications": "Notifications",
      "selectFacility": "Select facility",
      "allFacilities": "All Facilities",
      "facilityLabel": "Facility {{id}}"
    },
    "theme": {
      "toggle": "Toggle theme",
      "light": "Light",
      "dark": "Dark",
      "system": "System",
      "current": "Theme: {{name}}"
    },
    "appVersionLabel": "VynaEMR v{{version}}",
    "dobLabel": "DOB {{date}}",
    "pagination": {
      "previous": "Previous",
      "next": "Next",
      "pageOf": "Page {{current}} of {{total}}",
      "showing": "Showing {{from}} to {{to}} of {{total}}"
    },
    "table": {
      "empty": "No data",
      "loading": "Loading..."
    }
  },
  "encounter": {
    "admission": "Admission",
    "transfer": "Transfer",
    "visit": "Visit",
    "type": "Encounter Type",
    "status": "Status",
    "location": "Location",
    "attendingPhysician": "Attending Physician",
    "admitDate": "Admit Date",
    "dischargeDate": "Discharge Date",
    "chiefComplaint": "Chief Complaint",
    "diagnosis": "Diagnosis",
    "class": {
      "label": "Class",
      "values": {
        "emergency": "Emergency",
        "inpatient": "Inpatient",
        "outpatient": "Outpatient",
        "observation": "Observation",
        "ambulatory": "Ambulatory",
        "homeHealth": "Home Health",
        "virtual": "Virtual / Telehealth"
      }
    },
    "__review_class": "Encounter class categorisation varies by APAC health system — verify with local clinical reviewer. Ambulatory/home health/virtual added in Task 7A to back EncounterForm dropdown.",
    "statusValues": {
      "label": "Status",
      "values": {
        "pending": "Pending",
        "active": "Active",
        "completed": "Completed",
        "cancelled": "Cancelled"
      }
    },
    "admissionSource": {
      "label": "Admission Source",
      "none": "—",
      "values": {
        "emergency": "Emergency Department",
        "clinicReferral": "Clinic Referral",
        "physicianReferral": "Physician Referral",
        "transfer": "Transfer from Another Facility",
        "self": "Self-Referral / Walk-in",
        "courtLaw": "Court / Law Enforcement"
      }
    },
    "admissionType": {
      "label": "Admission Type",
      "none": "—",
      "values": {
        "elective": "Elective",
        "emergency": "Emergency",
        "urgent": "Urgent",
        "newborn": "Newborn",
        "trauma": "Trauma"
      }
    },
    "acuity": {
      "label": "Acuity",
      "none": "—",
      "values": {
        "1": "1 — Resuscitation",
        "2": "2 — Emergent",
        "3": "3 — Urgent",
        "4": "4 — Less Urgent",
        "5": "5 — Non-Urgent"
      },
      "shortValues": {
        "1": "Resuscitation",
        "2": "Emergent",
        "3": "Urgent",
        "4": "Less Urgent",
        "5": "Non-Urgent"
      },
      "esiBadge": "ESI {{level}} - {{label}}"
    },
    "__review_acuity": "ESI (Emergency Severity Index) is a US triage standard — APAC sites may localise to MTS (Manchester) or ATS (Australasian) labels. Verify with ED clinical reviewer.",
    "form": {
      "title": "New Encounter",
      "subtitle": "Start a new visit / admission for this patient.",
      "sections": {
        "visit": "Visit",
        "reasonForVisit": "Reason for Visit",
        "admission": "Admission"
      },
      "fields": {
        "facility": "Facility",
        "encounterClass": "Encounter Class",
        "encounterType": "Encounter Type",
        "department": "Department",
        "attendingProvider": "Attending Provider",
        "acuity": "Acuity",
        "visitReason": "Visit Reason",
        "chiefComplaint": "Chief Complaint",
        "admissionSource": "Admission Source",
        "admissionType": "Admission Type"
      },
      "placeholders": {
        "selectFacility": "Select facility",
        "none": "—",
        "encounterType": "e.g. Annual Physical, ER Visit",
        "visitReason": "Short label, e.g. Follow-up, Annual Physical",
        "chiefComplaint": "Patient's stated reason in their own words"
      },
      "providerFallback": "Provider #{{id}}",
      "submit": "Create Encounter",
      "validation": {
        "facilityRequired": "Facility is required",
        "encounterClassRequired": "Encounter class is required"
      },
      "createdSuccess": "Encounter created",
      "createError": "Failed to create encounter"
    },
    "detail": {
      "loading": "Loading encounter...",
      "notFound": "Encounter not found",
      "returnToDashboard": "Return to Dashboard",
      "header": {
        "title": "Encounter {{number}}",
        "facilityLabel": "Facility #{{id}}",
        "departmentLabel": "Dept #{{id}}",
        "locationLabel": "Location #{{id}}",
        "admittedLabel": "Admitted: {{datetime}}"
      },
      "actions": {
        "transfer": "Transfer",
        "discharge": "Discharge"
      },
      "tabs": {
        "overview": "Overview",
        "orders": "Orders",
        "results": "Results",
        "medications": "Medications",
        "notes": "Notes",
        "billing": "Billing"
      },
      "overview": {
        "chiefComplaint": "Chief Complaint",
        "visitReason": "Visit Reason",
        "attendingProvider": "Attending Provider",
        "acuityLevel": "Acuity Level",
        "providerFallback": "Provider #{{id}}",
        "empty": "--"
      },
      "timeline": {
        "title": "Event Timeline",
        "empty": "No events recorded",
        "admittedTitle": "Admitted",
        "admittedDescription": "{{class}} - {{chiefComplaint}}",
        "noChiefComplaint": "No chief complaint",
        "orderTitle": "Order: {{name}}",
        "orderDescription": "{{type}} - {{priority}} - {{status}}",
        "resultTitle": "Result: {{type}}"
      },
      "orders": {
        "title": "Orders",
        "newOrder": "+ New Order",
        "empty": "No orders for this encounter",
        "metaLine": "{{number}} | {{type}} | Priority: {{priority}}"
      },
      "results": {
        "title": "Results",
        "empty": "No results for this encounter",
        "criticalBadge": "CRITICAL",
        "viewLink": "View",
        "metaLine": "{{number}} | {{status}}"
      },
      "medications": {
        "title": "Medications",
        "newMedication": "+ New Medication",
        "empty": "No medications for this encounter",
        "prnBadge": "PRN",
        "prnWithIndication": "PRN: {{indication}}"
      },
      "notes": {
        "comingSoon": "Clinical notes module coming soon",
        "goToClinicalNotes": "Go to Clinical Notes"
      },
      "billing": {
        "comingSoon": "Billing module coming soon"
      }
    },
    "__review_detail": "Tab and timeline phrasing leans on Commonwealth EMR conventions (ED, OR, ICU verbatim). Tamil, Hindi, zh-HK should be reviewed for clinical register and ambiguity around 'Order' vs 'Prescription'.",
    "census": {
      "title": "Bed Board / Census",
      "subtitle": "Real-time bed occupancy and patient census",
      "refresh": "Refresh",
      "facilityName": "Singapore General Hospital",
      "capacitySummary": "{{occupied}} occupied / {{total}} total beds",
      "occupancyLabel": "{{percent}}% occupancy",
      "stats": {
        "totalCapacity": "Total Capacity",
        "occupied": "Occupied",
        "available": "Available",
        "pendingDischarge": "Pending Discharge"
      },
      "unitFilter": {
        "all": "All Units",
        "er": "ER",
        "icu": "ICU",
        "medsurg": "Med/Surg",
        "obs": "Observation",
        "peds": "Pediatrics",
        "maternity": "Maternity"
      },
      "roleView": {
        "nurse": "Nurse View",
        "physician": "Physician View",
        "bedManager": "Bed Manager View"
      },
      "viewMode": {
        "grid": "Grid view",
        "table": "Table view"
      },
      "loading": "Loading census data...",
      "columns": {
        "patient": "Patient",
        "mrn": "MRN",
        "admitDate": "Admit Date",
        "status": "Status",
        "acuity": "Acuity",
        "isolation": "Isolation",
        "fallRisk": "Fall Risk",
        "codeStatus": "Code Status",
        "chiefComplaint": "Chief Complaint",
        "attending": "Attending",
        "los": "LOS",
        "locationBed": "Location / Bed",
        "transferStatus": "Transfer Status",
        "expectedDischarge": "Expected Discharge",
        "actions": "Actions"
      },
      "values": {
        "unknownPatient": "Unknown",
        "none": "None",
        "notAvailable": "N/A",
        "pending": "Pending",
        "empty": "--",
        "providerFallback": "Provider #{{id}}",
        "locationLabel": "Location #{{id}}",
        "losDays": "{{days}}d"
      },
      "codeStatusTooltip": "Code status is available on the patient chart",
      "actionsMenu": {
        "label": "Actions",
        "viewChart": "View Chart",
        "transfer": "Transfer",
        "discharge": "Discharge"
      },
      "empty": "No active encounters found"
    },
    "__review_census": "Census labels (Bed Board, ESI acuity, role views, code status) lean on US/Commonwealth conventions — verify with bed-management SMEs for APAC sites that may prefer ATS triage or 'ward census' phrasing.",
    "discharge": {
      "label": "Discharge",
      "title": "Discharge Workflow",
      "encounterLabel": "Encounter {{number}}",
      "printButton": "Print Discharge",
      "loading": "Loading encounter...",
      "notFound": "Encounter not found",
      "returnToDashboard": "Return to Dashboard",
      "notActive": "This encounter is not active (status: {{status}})",
      "backToEncounter": "Back to Encounter",
      "progress": {
        "requiredMissingTooltip": "Required fields missing",
        "tasksRemainingTooltip": "Some tasks remaining"
      },
      "steps": {
        "summary": "Discharge Summary",
        "medications": "Medications",
        "followup": "Follow-up",
        "instructions": "Instructions",
        "nursing": "Nursing Tasks",
        "signoff": "Attending Sign-off",
        "review": "Review & Confirm"
      },
      "summary": {
        "title": "Discharge Summary",
        "diagnosisLabel": "Discharge Diagnosis *",
        "diagnosisPlaceholder": "Enter discharge diagnosis...",
        "diagnosisCodeLabel": "Discharge Diagnosis Code (ICD-10)",
        "diagnosisCodePlaceholder": "Search ICD-10 code...",
        "proceduresLabel": "Procedures Performed",
        "proceduresPlaceholder": "List procedures performed during this encounter...",
        "conditionLabel": "Condition at Discharge *"
      },
      "condition": {
        "values": {
          "stable": "Stable",
          "improved": "Improved",
          "unchanged": "Unchanged",
          "worsened": "Worsened",
          "critical": "Critical"
        }
      },
      "__review_condition": "Condition-at-discharge categorisation (stable/improved/unchanged/worsened/critical) follows US/Commonwealth discharge-summary convention; APAC sites may prefer 'guarded' or numeric scales — verify with clinical reviewer.",
      "medications": {
        "title": "Discharge Medications",
        "instructions": "Review each medication and decide whether to continue, stop, or modify at discharge.",
        "actions": {
          "continue": "Continue",
          "stop": "Stop",
          "modify": "Modify"
        },
        "modifiedPlaceholder": "Enter modified instructions...",
        "empty": "No active medications for this encounter"
      },
      "medAction": {
        "values": {
          "continue": "continue",
          "stop": "stop",
          "modify": "modify"
        }
      },
      "followup": {
        "title": "Follow-up Appointments",
        "providerLabel": "Follow-up Provider",
        "providerPlaceholder": "Provider name or specialty...",
        "dateLabel": "Follow-up Date",
        "notesLabel": "Additional Notes",
        "notesPlaceholder": "Any additional follow-up notes..."
      },
      "instructions": {
        "title": "Patient Instructions",
        "generalLabel": "General Instructions",
        "generalPlaceholder": "General discharge instructions for the patient...",
        "dietaryLabel": "Dietary Instructions",
        "dietaryPlaceholder": "Any dietary restrictions or recommendations...",
        "activityLabel": "Activity Restrictions",
        "activityPlaceholder": "Physical activity limitations...",
        "warningSignsLabel": "Warning Signs to Watch For",
        "warningSignsPlaceholder": "Symptoms that should prompt the patient to return or seek care..."
      },
      "nursing": {
        "title": "Nursing Tasks",
        "instructions": "Complete the following checklist before discharge. These tasks are informational and do not require an API call.",
        "tasks": {
          "removeIv": "Remove IV access",
          "discontinueMonitoring": "Discontinue monitoring equipment",
          "patientEducation": "Patient education completed",
          "medsReviewed": "Discharge medications reviewed with patient",
          "belongingsReturned": "Personal belongings returned",
          "transportArranged": "Transport arranged"
        }
      },
      "__review_nursing": "Pre-discharge nursing-task checklist (IV removal, monitoring discontinue, transport arranged, etc.) follows US/Commonwealth ward conventions — APAC sites may add discharge-summary signature or insurance-clearance items. Verify with nursing SME.",
      "signoff": {
        "title": "Attending Sign-off",
        "instructions": "Review the discharge summary below and provide attending sign-off.",
        "diagnosisHeading": "Discharge Diagnosis",
        "notProvided": "Not provided",
        "medicationsHeading": "Discharge Medications",
        "noMedications": "No medications to reconcile",
        "signedCompleted": "Attending sign-off completed.",
        "signAsAttending": "Sign as Attending",
        "requiresAttendingSignoff": "Requires attending physician sign-off"
      },
      "review": {
        "title": "Review & Confirm Discharge",
        "summaryHeading": "Discharge Summary",
        "fields": {
          "diagnosis": "Diagnosis:",
          "procedures": "Procedures:",
          "condition": "Condition:",
          "provider": "Provider:",
          "date": "Date:",
          "notes": "Notes:",
          "general": "General:",
          "diet": "Diet:",
          "activity": "Activity:",
          "warningSigns": "Warning Signs:"
        },
        "medicationsHeading": "Medication Reconciliation",
        "noMedications": "No medications to reconcile",
        "followupHeading": "Follow-up",
        "instructionsHeading": "Patient Instructions",
        "noInstructions": "No instructions provided",
        "pendingOrdersWarning": "There may be pending orders or unsigned notes. Verify before completing discharge.",
        "diagnosisRequired": "Discharge diagnosis is required before completing the discharge.",
        "empty": "--"
      },
      "nav": {
        "previous": "Previous",
        "next": "Next",
        "complete": "Complete Discharge"
      },
      "toast": {
        "success": "Patient discharged successfully",
        "error": "Failed to complete discharge"
      }
    }
  },
  "fhir": {},
  "handoff": {
    "title": "Patient Handoff (I-PASS)",
    "illnessSeverity": "Illness Severity",
    "patientSummary": "Patient Summary",
    "actionList": "Action List",
    "situationAwareness": "Situation Awareness",
    "synthesis": "Synthesis by Receiver",
    "acknowledge": "Acknowledge Handoff",
    "severity": {
      "stable": "Stable",
      "watcher": "Watcher",
      "unstable": "Unstable"
    }
  },
  "interfaces": {},
  "medications": {
    "mar": "Medication Administration Record",
    "name": "Medication Name",
    "dose": "Dose",
    "route": "Route",
    "frequency": "Frequency",
    "startDate": "Start Date",
    "endDate": "End Date",
    "administeredBy": "Administered By",
    "administeredAt": "Administered At",
    "scheduled": "Scheduled",
    "given": "Given",
    "held": "Held",
    "refused": "Refused",
    "missed": "Missed"
  },
  "nav": {
    "breadcrumbAriaLabel": "Breadcrumb",
    "homeAriaLabel": "Home",
    "mainNavAriaLabel": "Main navigation",
    "closeSidebarAriaLabel": "Close sidebar",
    "collapse": "Collapse",
    "help": "Help",
    "settings": "Settings",
    "myProfile": "My Profile",
    "groups": {
      "clinical": "Clinical",
      "worklists": "Worklists",
      "__review_worklists": "Clinical-workflow term; verify register and singular/plural in Tamil, Hindi, and zh-HK.",
      "documentation": "Documentation",
      "orders": "Orders",
      "medications": "Medications",
      "scheduling": "Scheduling",
      "billing": "Billing",
      "analytics": "Analytics",
      "organization": "Organization",
      "security": "Security",
      "integrations": "Integrations",
      "system": "System",
      "licensing": "Licensing"
    },
    "dashboard": "Dashboard",
    "patients": "Patients",
    "patientSearch": "Patient Search",
    "censusBedBoard": "Census / Bed Board",
    "__review_censusBedBoard": "Clinical-operations term; some APAC locales may prefer 'bed roster' or facility-specific naming. Verify with clinical SMEs per jurisdiction.",
    "providerDirectory": "Provider Directory",
    "providerCoverage": "Provider Coverage",
    "patientMerge": "Patient Merge",
    "pendingResults": "Pending Results",
    "criticalResults": "Critical Results",
    "unsignedNotes": "Unsigned Notes",
    "cosignQueue": "Cosign Queue",
    "noteTemplates": "Note Templates",
    "smartPhrases": "Smart Phrases",
    "orderCatalog": "Order Catalog",
    "orderSets": "Order Sets",
    "encounters": "Encounters",
    "orders": "Orders",
    "results": "Results",
    "medications": "Medications",
    "notes": "Notes",
    "formulary": "Formulary",
    "pharmacistQueue": "Pharmacist Queue",
    "appointments": "Appointments",
    "scheduleManagement": "Schedule Management",
    "waitlist": "Waitlist",
    "charges": "Charges",
    "claims": "Claims",
    "payments": "Payments",
    "accounts": "Accounts",
    "statements": "Statements",
    "denials": "Denials",
    "analyticsDashboard": "Dashboard",
    "reports": "Reports",
    "qualityMeasures": "Quality Measures",
    "healthSystems": "Health Systems",
    "facilities": "Facilities",
    "locations": "Locations",
    "clinicalTaxonomy": "Clinical Taxonomy",
    "serviceLocation": "Service ↔ Location",
    "providers": "Providers",
    "users": "Users",
    "roles": "Roles",
    "accessMatrix": "Access Matrix",
    "integrations": "Integrations",
    "thirdPartyApps": "Third-Party Apps",
    "audit": "Audit",
    "system": "System",
    "cdsRules": "CDS Rules",
    "tiers": "Tiers",
    "pricing": "Pricing",
    "usage": "Usage",
    "segments": {
      "search": "Search",
      "register": "Register",
      "demographics": "Demographics",
      "census": "Census",
      "__review_census": "Standalone breadcrumb segment for /encounters/census; same caveat as nav.censusBedBoard — some APAC locales may prefer 'bed roster'.",
      "discharge": "Discharge",
      "catalog": "Catalog",
      "sets": "Order Sets",
      "pending": "Pending",
      "critical": "Critical",
      "reconciliation": "Reconciliation",
      "worklist": "Worklist",
      "__review_worklist": "Singular breadcrumb form of nav.groups.worklists; same register caveat.",
      "templates": "Templates",
      "smartPhrases": "Smart Phrases",
      "schedule": "Schedule Management",
      "quality": "Quality Measures",
      "administration": "Administration",
      "auditLog": "Audit Log",
      "allergies": "Allergies",
      "problems": "Problems",
      "immunizations": "Immunizations",
      "insurance": "Insurance"
    }
  },
  "notes": {
    "clinicalNotes": "Clinical Notes",
    "noteType": "Note Type",
    "author": "Author",
    "dateTime": "Date/Time",
    "content": "Content",
    "addNote": "Add Note",
    "editNote": "Edit Note",
    "signNote": "Sign Note",
    "signed": "Signed",
    "unsigned": "Unsigned",
    "types": {
      "progressNote": "Progress Note",
      "admissionNote": "Admission Note",
      "dischargeNote": "Discharge Note",
      "consultNote": "Consultation Note",
      "procedureNote": "Procedure Note"
    }
  },
  "orders": {
    "entry": "Order Entry",
    "catalog": "Order Catalog",
    "orderedBy": "Ordered By",
    "orderedDate": "Ordered Date",
    "scheduledDate": "Scheduled Date",
    "completedDate": "Completed Date",
    "lab": "Laboratory",
    "imaging": "Imaging",
    "medication": "Medication",
    "procedure": "Procedure",
    "consultation": "Consultation",
    "priority": {
      "label": "Priority",
      "values": {
        "stat": "STAT",
        "asap": "ASAP",
        "urgent": "Urgent",
        "routine": "Routine",
        "scheduled": "Scheduled",
        "prn": "PRN"
      }
    },
    "__review_priority": "STAT / ASAP / PRN are clinical acronyms kept verbatim across all locales per Phase-2 register policy (Task 3 M-1). Only `urgent`, `routine`, `scheduled` translate. Phase-0 seeds that softened STAT to '紧急 / 至急 / CẤP CỨU' have been hardened.",
    "status": {
      "label": "Order Status",
      "values": {
        "draft": "Draft",
        "pending": "Pending",
        "signed": "Signed",
        "sent": "Sent",
        "active": "Active",
        "ordered": "Ordered",
        "inProgress": "In Progress",
        "holdForVerify": "Hold for Verification",
        "completed": "Completed",
        "cancelled": "Cancelled",
        "discontinued": "Discontinued",
        "archived": "Archived"
      }
    },
    "entryFields": {
      "searchPlaceholder": "Search orders (labs, imaging, meds, procedures)…",
      "frequency": "Frequency",
      "dose": "Dose",
      "route": "Route",
      "indication": "Indication",
      "duration": "Duration",
      "comments": "Comments",
      "signOrder": "Sign Order",
      "holdOrder": "Hold Order",
      "frequencyOptions": {
        "stat": "STAT",
        "prn": "PRN",
        "bid": "BID",
        "tid": "TID",
        "qid": "QID",
        "qd": "QD",
        "qhs": "QHS",
        "ac": "AC",
        "pc": "PC"
      }
    },
    "catalogPage": {
      "title": "Order Catalog",
      "searchPlaceholder": "Search orders by name, code, or synonym…",
      "categories": "Categories",
      "favorites": "Favorites",
      "recentlyUsed": "Recently Used",
      "restricted": "Restricted",
      "searchCatalog": "Search Catalog",
      "tabs": {
        "all": "All",
        "lab": "Lab",
        "imaging": "Imaging",
        "medication": "Medication",
        "procedure": "Procedure",
        "consultation": "Consultation"
      },
      "columns": {
        "orderName": "Order Name",
        "code": "Code",
        "category": "Category",
        "description": "Description",
        "defaultPriority": "Default Priority"
      },
      "details": {
        "orderCode": "Order Code",
        "category": "Category",
        "defaultPriority": "Default Priority",
        "status": "Status",
        "cptCode": "CPT Code",
        "loincCode": "LOINC Code",
        "synonyms": "Synonyms",
        "description": "Description",
        "active": "Active",
        "inactive": "Inactive"
      },
      "loading": "Loading catalog…",
      "loadError": "Failed to load order catalog",
      "emptyResults": "No orders found matching your criteria.",
      "pagination": "Showing {{from}}-{{to}} of {{total}}",
      "pageIndicator": "Page {{page}} of {{totalPages}}",
      "favoriteAdd": "Add to favorites",
      "favoriteRemove": "Remove from favorites",
      "favoriteAdded": "Added to favorites",
      "favoriteRemoved": "Removed from favorites"
    },
    "cosign": {
      "title": "Order Cosign Queue",
      "requiresCosign": "Requires Cosign",
      "cosignedBy": "Cosigned By",
      "cosignDeadline": "Cosign Deadline",
      "queueEmpty": "No orders require cosigning.",
      "pendingCount": "{{count}} pending",
      "loading": "Loading cosign queue…",
      "loadError": "Failed to load cosign queue.",
      "columns": {
        "patient": "Patient",
        "order": "Order",
        "type": "Type",
        "orderingProvider": "Ordering Provider",
        "priority": "Priority",
        "orderedDate": "Ordered Date",
        "action": "Action"
      },
      "actions": {
        "cosign": "Cosign"
      },
      "toast": {
        "success": "Order cosigned successfully",
        "error": "Failed to cosign order"
      },
      "cosigningAs": "Cosigning as: {{name}}"
    },
    "sets": {
      "title": "Order Sets",
      "newOrderSet": "New Order Set",
      "addItem": "Add Item",
      "requiredItem": "Required",
      "optionalItem": "Optional",
      "editMode": "Edit Mode",
      "published": "Published",
      "draft": "Draft",
      "archived": "Archived",
      "versionNotes": "Version Notes",
      "createTitle": "Create New Order Set",
      "fields": {
        "name": "Name",
        "category": "Category",
        "specialty": "Specialty",
        "description": "Description"
      },
      "placeholders": {
        "name": "e.g., Chest Pain Workup",
        "categorySelect": "Select category…",
        "specialty": "e.g., Emergency Medicine",
        "description": "Brief description…",
        "search": "Search order sets…"
      },
      "categories": {
        "chestPain": "Chest Pain",
        "sepsis": "Sepsis",
        "postOp": "Post-Op",
        "admission": "Admission",
        "discharge": "Discharge",
        "other": "Other"
      },
      "statusFilter": {
        "all": "All Statuses",
        "active": "Active",
        "draft": "Draft",
        "archived": "Archived"
      },
      "columns": {
        "name": "Name",
        "category": "Category",
        "specialty": "Specialty",
        "items": "Items",
        "status": "Status",
        "version": "Version",
        "actions": "Actions"
      },
      "itemColumns": {
        "seq": "Seq",
        "type": "Type",
        "item": "Item",
        "priority": "Priority",
        "required": "Required"
      },
      "itemTypes": {
        "order": "Order",
        "sectionHeader": "Section Header",
        "instruction": "Instruction"
      },
      "actions": {
        "publish": "Publish",
        "archive": "Archive",
        "cancel": "Cancel",
        "create": "Create",
        "removeItem": "Remove item"
      },
      "loading": "Loading order sets…",
      "loadError": "Failed to load order sets",
      "emptyResults": "No order sets found.",
      "expandLoading": "Loading items…",
      "expandEmpty": "No items in this order set.",
      "validationRequired": "Name, category, and specialty are required",
      "toast": {
        "created": "Order set created",
        "createError": "Failed to create order set",
        "published": "Order set published",
        "publishError": "Failed to publish order set",
        "archived": "Order set archived",
        "archiveError": "Failed to archive order set",
        "itemRemoved": "Item removed",
        "itemRemoveError": "Failed to remove item"
      },
      "versionBadge": "v{{version}}"
    },
    "search": {
      "placeholder": "Search orders (labs, imaging, meds, procedures)…",
      "noResults": "No orders found for \"{{query}}\"",
      "categories": {
        "lab": "Lab",
        "imaging": "Imaging",
        "med": "Med",
        "procedure": "Procedure"
      }
    }
  },
  "patient": {
    "chart": "Patient Chart",
    "mrn": "MRN",
    "demographics": {
      "pageTitle": "Demographics",
      "loading": "Loading patient demographics...",
      "loadError": "Failed to load patient demographics.",
      "returnToDashboard": "Return to Dashboard",
      "updatedSuccess": "Patient demographics updated",
      "updateError": "Failed to update patient demographics",
      "sections": {
        "personalInformation": "Personal Information",
        "identification": "Identification",
        "contactInformation": "Contact Information",
        "address": "Address",
        "languageAndPreferences": "Language & Preferences",
        "specialFlags": "Special Flags",
        "recordInformation": "Record Information"
      },
      "fields": {
        "fullName": "Full Name",
        "alternativeName": "Alternative Name",
        "preferredName": "Preferred Name",
        "dateOfBirth": "Date of Birth",
        "age": "Age",
        "legalGender": "Legal Gender",
        "genderIdentity": "Gender Identity",
        "race": "Race",
        "ethnicity": "Ethnicity",
        "nationality": "Nationality",
        "mrn": "MRN",
        "nationalIdType": "National ID Type",
        "nationalIdNumber": "National ID Number",
        "passportNumber": "Passport Number",
        "passportCountry": "Passport Country",
        "primaryPhone": "Primary Phone",
        "mobilePhone": "Mobile Phone",
        "email": "Email",
        "preferredContactMethod": "Preferred Contact Method",
        "addressLine1": "Address Line 1",
        "addressLine2": "Address Line 2",
        "city": "City",
        "stateProvince": "State/Province",
        "postalCode": "Postal Code",
        "country": "Country",
        "primaryLanguage": "Primary Language",
        "secondaryLanguage": "Secondary Language",
        "interpreterRequired": "Interpreter Required",
        "vipStatus": "VIP Status",
        "confidentialityLevel": "Confidentiality Level",
        "medicalTourist": "Medical Tourist",
        "homeCountry": "Home Country",
        "status": "Status",
        "deceased": "Deceased",
        "created": "Created",
        "lastModified": "Last Modified"
      },
      "statusValues": {
        "active": "Active",
        "inactive": "Inactive"
      },
      "deceasedSummary": "Yes ({{date}})",
      "deceasedDateUnknown": "Date unknown",
      "legalGender": {
        "label": "Legal Gender",
        "values": {
          "male": "Male",
          "female": "Female",
          "other": "Other",
          "unknown": "Unknown"
        },
        "selectPlaceholder": "Select Gender"
      },
      "preferredContactMethod": {
        "label": "Preferred Contact Method",
        "values": {
          "phone": "Phone",
          "mobile": "Mobile",
          "email": "Email",
          "sms": "SMS"
        },
        "notSpecified": "Not specified"
      },
      "validation": {
        "fullNameRequired": "Full name is required",
        "dateOfBirthRequired": "Date of birth is required",
        "countryRequired": "Country is required",
        "primaryLanguageRequired": "Primary language is required",
        "invalidEmail": "Invalid email",
        "nationalIdValidationFailed": "National ID validation failed: {{error}}"
      }
    },
    "registration": {
      "title": "Patient Registration",
      "subtitle": "Register a new patient in the system",
      "submit": "Register Patient",
      "submitting": "Registering...",
      "checkingDuplicates": "Checking for duplicates...",
      "registerNew": "Register New Patient",
      "registeredSuccess": "Patient registered successfully",
      "registerError": "Failed to register patient",
      "validationNationalIdFailed": "National ID validation failed: {{error}}",
      "sections": {
        "basicInformation": "Basic Information",
        "identification": "Identification",
        "contactInformation": "Contact Information",
        "address": "Address",
        "languageAndCommunication": "Language & Communication",
        "additionalInformation": "Additional Information"
      },
      "placeholders": {
        "fullName": "e.g., Tan Wei Ming or 李小明",
        "alternativeName": "Romanized version if applicable",
        "preferredName": "Name patient prefers to be called",
        "nationalIdNumberDefault": "Enter national ID number",
        "primaryPhone": "+65 9123 4567",
        "mobilePhone": "+65 8123 4567",
        "email": "patient@example.com"
      },
      "helperText": {
        "fullName": "Enter the patient's full name as it appears on official documents"
      },
      "flags": {
        "vipPatient": "VIP Patient",
        "medicalTourist": "Medical Tourist"
      },
      "duplicate": {
        "title": "Potential Duplicate Patients Found",
        "body": "The following existing patients match the information you entered:",
        "mrnLabel": "MRN",
        "dobLabel": "DOB",
        "idLabel": "ID",
        "matchSummary": "Match: {{score}}% ({{reasons}})",
        "useExisting": "Use Existing",
        "createNew": "This is a New Patient"
      }
    },
    "search": {
      "title": "Patient Search",
      "subtitle": "Search and manage patient records",
      "placeholder": "Search by patient name, MRN, or ID...",
      "advancedFilters": "Advanced Filters",
      "filters": {
        "mrnPlaceholder": "e.g., P0000000001",
        "fullNamePlaceholder": "Patient name",
        "phonePlaceholder": "Phone number",
        "emailPlaceholder": "Email address"
      },
      "filterLabels": {
        "mrn": "MRN",
        "fullName": "Full Name",
        "dateOfBirth": "Date of Birth",
        "phone": "Phone",
        "email": "Email",
        "country": "Country",
        "status": "Status",
        "vip": "VIP"
      },
      "vipFilter": {
        "all": "All",
        "vipOnly": "VIP Only",
        "nonVipOnly": "Non-VIP Only"
      },
      "statusFilter": {
        "all": "All",
        "active": "Active",
        "inactive": "Inactive"
      },
      "countryFilter": {
        "all": "All Countries"
      },
      "clearFilters": "Clear Filters",
      "dateOfBirthAria": "Date of Birth filter",
      "columns": {
        "mrn": "MRN",
        "fullName": "Full Name",
        "dob": "DOB",
        "gender": "Gender",
        "phone": "Phone",
        "country": "Country",
        "status": "Status"
      },
      "results": {
        "searching": "Searching patients...",
        "loadError": "Failed to load patients. Please try again.",
        "empty": "No patients found. Try adjusting your search criteria.",
        "showing": "Showing {{from}} to {{to}} of {{total}} patients"
      }
    },
    "encounters": {
      "title": "Encounters",
      "create": "Create Encounter",
      "filters": "Filters",
      "filterLabels": {
        "status": "Status",
        "class": "Class",
        "fromDate": "From Date",
        "toDate": "To Date"
      },
      "filterPlaceholders": {
        "allStatuses": "All Statuses",
        "allClasses": "All Classes"
      },
      "clearFilters": "Clear Filters",
      "fromDateAria": "From Date",
      "toDateAria": "To Date",
      "columns": {
        "encounterNumber": "Encounter #",
        "class": "Class",
        "status": "Status",
        "admitDate": "Admit Date",
        "dischargeDate": "Discharge Date",
        "location": "Location",
        "chiefComplaint": "Chief Complaint"
      },
      "locationLabel": "Location #{{id}}",
      "loading": "Loading encounters...",
      "loadError": "Failed to load encounters.",
      "empty": "No encounters found for this patient.",
      "showing": "Showing {{from}} to {{to}} of {{total}}"
    },
    "identifiers": {
      "nationalIdType": {
        "label": "National ID Type",
        "none": "None",
        "values": {
          "nric": "NRIC",
          "hkid": "HKID",
          "myKad": "MyKad",
          "aadhaar": "Aadhaar",
          "ktp": "KTP",
          "myNumber": "My Number",
          "thaiNationalId": "Thai National ID"
        },
        "country": {
          "nric": "Singapore",
          "hkid": "Hong Kong",
          "myKad": "Malaysia",
          "aadhaar": "India",
          "ktp": "Indonesia",
          "myNumber": "Japan",
          "thaiNationalId": "Thailand"
        },
        "placeholderByType": {
          "nric": "e.g., S1234567D",
          "myKad": "e.g., 850101-14-5678",
          "hkid": "e.g., A123456(3)",
          "aadhaar": "e.g., 2341 2341 2346",
          "thaiNationalId": "e.g., 1-2345-45678-78-1"
        }
      },
      "nationalIdCheck": {
        "checksumMismatch": "The check character does not match this ID type. Verify the number against the patient's identity document.",
        "unavailable": "This ID number could not be checked. Verify it against the patient's identity document.",
        "acknowledge": "I have verified this number against the identity document",
        "acknowledgeRequired": "Verify the national ID number against the identity document and confirm before saving."
      },
      "__review_nationalIdType": "Country-specific identifier verbiage — verify with local clinical/admin reviewer before APAC pilot rollout"
    },
    "country": {
      "values": {
        "sg": "Singapore",
        "my": "Malaysia",
        "th": "Thailand",
        "id": "Indonesia",
        "ph": "Philippines",
        "vn": "Vietnam",
        "hk": "Hong Kong",
        "tw": "Taiwan",
        "jp": "Japan",
        "kr": "South Korea",
        "cn": "China",
        "in": "India",
        "au": "Australia",
        "nz": "New Zealand"
      }
    },
    "language": {
      "values": {
        "en": "English",
        "zh": "Chinese (Mandarin)",
        "ms": "Malay",
        "ta": "Tamil",
        "th": "Thai",
        "id": "Indonesian",
        "vi": "Vietnamese",
        "ja": "Japanese",
        "ko": "Korean",
        "hi": "Hindi"
      }
    },
    "contact": {
      "addTitle": "Add Contact",
      "editTitle": "Edit Contact",
      "name": "Name",
      "relationship": {
        "label": "Relationship",
        "selectPlaceholder": "Select...",
        "values": {
          "spouse": "Spouse",
          "parent": "Parent",
          "child": "Child",
          "sibling": "Sibling",
          "guardian": "Guardian",
          "friend": "Friend",
          "other": "Other"
        }
      },
      "phone": "Phone",
      "email": "Email",
      "emergencyContact": "Emergency contact",
      "validation": {
        "nameRequired": "Contact name is required",
        "relationshipRequired": "Relationship is required",
        "phoneRequired": "Phone number is required",
        "invalidEmail": "Invalid email"
      },
      "savedSuccess": "Contact added successfully",
      "saveError": "Failed to add contact"
    },
    "immunization": {
      "addTitle": "Add Immunization",
      "vaccineName": "Vaccine Name",
      "vaccineNamePlaceholder": "e.g., Influenza, COVID-19 (Pfizer), Hepatitis B",
      "vaccineCode": "Vaccine Code (CVX)",
      "vaccineCodePlaceholder": "e.g., 141",
      "administeredDate": "Date Administered",
      "lotNumber": "Lot Number",
      "lotNumberPlaceholder": "e.g., AB1234",
      "site": {
        "label": "Site",
        "selectPlaceholder": "Select site",
        "values": {
          "leftDeltoid": "Left Deltoid",
          "rightDeltoid": "Right Deltoid",
          "leftThigh": "Left Thigh",
          "rightThigh": "Right Thigh",
          "leftGluteal": "Left Gluteal",
          "rightGluteal": "Right Gluteal",
          "other": "Other"
        }
      },
      "route": {
        "label": "Route",
        "selectPlaceholder": "Select route",
        "values": {
          "intramuscular": "Intramuscular (IM)",
          "subcutaneous": "Subcutaneous (SC)",
          "intradermal": "Intradermal (ID)",
          "oral": "Oral",
          "intranasal": "Intranasal"
        }
      },
      "doseAmount": "Dose Amount",
      "doseAmountPlaceholder": "e.g., 0.5 mL",
      "administeredBy": "Administered By",
      "administeredByPlaceholder": "Provider name or ID",
      "nextDueDate": "Next Due Date",
      "notes": "Notes",
      "notesPlaceholder": "Additional notes...",
      "validation": {
        "vaccineNameRequired": "Vaccine name is required",
        "administeredDateRequired": "Date administered is required"
      },
      "savedSuccess": "Immunization record added",
      "saveError": "Failed to add immunization record"
    },
    "insurance": {
      "addTitle": "Add Insurance Plan",
      "submitLabel": "Add Insurance",
      "payerName": "Payer Name",
      "payerNamePlaceholder": "e.g., AIA Singapore",
      "payerId": "Payer ID",
      "payerIdPlaceholder": "Payer identifier",
      "planName": "Plan Name",
      "planNamePlaceholder": "e.g., HealthShield Gold Max",
      "planType": {
        "label": "Plan Type",
        "selectPlaceholder": "Select type",
        "values": {
          "hmo": "HMO",
          "ppo": "PPO",
          "epo": "EPO",
          "pos": "POS",
          "government": "Government",
          "private": "Private",
          "corporate": "Corporate",
          "other": "Other"
        }
      },
      "memberId": "Member ID",
      "memberIdPlaceholder": "Member ID number",
      "groupNumber": "Group Number",
      "groupNumberPlaceholder": "Group number",
      "subscriberName": "Subscriber Name",
      "subscriberNamePlaceholder": "If different from patient",
      "subscriberRelationship": {
        "label": "Subscriber Relationship",
        "values": {
          "self": "Self",
          "spouse": "Spouse",
          "child": "Child",
          "parent": "Parent",
          "other": "Other"
        }
      },
      "priority": {
        "label": "Priority",
        "values": {
          "primary": "Primary",
          "secondary": "Secondary",
          "tertiary": "Tertiary"
        }
      },
      "effectiveDate": "Effective Date",
      "terminationDate": "Termination Date",
      "copayAmount": "Copay Amount ($)",
      "coinsurancePercent": "Coinsurance (%)",
      "deductibleAmount": "Deductible ($)",
      "outOfPocketMax": "Out-of-Pocket Max ($)",
      "preAuthRequired": "Pre-authorization Required",
      "notes": "Notes",
      "notesPlaceholder": "Additional notes...",
      "validation": {
        "payerNameRequired": "Payer name is required",
        "planNameRequired": "Plan name is required",
        "memberIdRequired": "Member ID is required",
        "effectiveDateRequired": "Effective date is required"
      },
      "savedSuccess": "Insurance plan added",
      "saveError": "Failed to add insurance plan"
    },
    "problem": {
      "addTitle": "Add Problem",
      "problemName": "Problem Name",
      "problemNamePlaceholder": "e.g., Type 2 Diabetes Mellitus",
      "icdCode": "ICD-10 Code",
      "icdSearchPlaceholder": "Search ICD-10 code or description...",
      "onsetDate": "Onset Date",
      "severity": {
        "label": "Severity",
        "values": {
          "mild": "Mild",
          "moderate": "Moderate",
          "severe": "Severe"
        }
      },
      "notes": "Notes",
      "notesPlaceholder": "Additional clinical notes...",
      "validation": {
        "problemNameRequired": "Problem name is required"
      },
      "savedSuccess": "Problem added to problem list",
      "saveError": "Failed to add problem"
    },
    "accounts": {
      "pageTitle": "Patient Accounts",
      "backToDashboard": "Dashboard",
      "searchPatientLabel": "Search Patient",
      "searchPlaceholder": "Search by name or MRN...",
      "searching": "Searching...",
      "noPatientsFound": "No patients found",
      "loadingAccount": "Loading account...",
      "mrnLabel": "MRN",
      "generateStatement": "Generate Statement",
      "statementComingSoon": "Statement generation coming soon",
      "paymentPlan": "Payment Plan",
      "paymentPlanComingSoon": "Payment plan setup coming soon",
      "totalCharges": "Total Charges",
      "totalPayments": "Total Payments",
      "adjustments": "Adjustments",
      "outstandingBalance": "Outstanding Balance",
      "transactionHistory": "Transaction History",
      "columns": {
        "date": "Date",
        "type": "Type",
        "description": "Description",
        "amount": "Amount",
        "balance": "Balance"
      },
      "transactionType": {
        "label": "Type",
        "values": {
          "charge": "Charge",
          "payment": "Payment",
          "adjustment": "Adjustment"
        }
      },
      "loadingTransactions": "Loading transactions...",
      "noTransactionsFound": "No transactions found",
      "emptyState": "Search for a patient to view their account"
    },
    "proxies": {
      "title": "Authorized Representatives",
      "description": "Caregivers, guardians, and legal representatives authorized to access this patient's portal data. Revoked entries are kept for audit.",
      "addProxy": "Add Proxy",
      "newRelationshipHeading": "New proxy relationship",
      "proxyUserId": "Proxy user ID",
      "proxyUserIdPlaceholder": "User ID (from Admin → Users)",
      "proxyUserIdHelper": "Look up in Admin → Users. User-picker component comes in a follow-up.",
      "relationship": {
        "label": "Relationship",
        "values": {
          "parent": "Parent",
          "legalGuardian": "Legal Guardian",
          "spousePartner": "Spouse / Partner",
          "adultChild": "Adult Child",
          "powerOfAttorney": "Power of Attorney",
          "healthcareAgent": "Healthcare Agent"
        }
      },
      "accessLevel": {
        "label": "Access level",
        "values": {
          "full": "Full",
          "limited": "Limited",
          "emergency": "Emergency"
        },
        "descriptions": {
          "full": "All portal data — appointments, results, messages, forms.",
          "limited": "Appointments + messages only (typical for adolescents).",
          "emergency": "Break-glass-equivalent for healthcare agents when the patient is incapacitated."
        }
      },
      "startDate": "Start date",
      "endDate": "End date",
      "startDateAria": "Effective start date",
      "endDateAria": "Effective end date",
      "grantAccess": "Grant proxy access",
      "userIdRequired": "Proxy user id required",
      "createdSuccess": "Proxy relationship created",
      "duplicateError": "This person is already a proxy with that relationship",
      "invalidDataError": "Invalid proxy data",
      "createError": "Failed to create proxy",
      "revokedSuccess": "Proxy access revoked",
      "revokeError": "Failed to revoke proxy",
      "emptyState": "No proxies configured. Grant access to a caregiver, guardian, or healthcare agent using the button above.",
      "sections": {
        "active": "Active ({{count}})",
        "plannedInactive": "Planned / Inactive ({{count}})",
        "revoked": "Revoked ({{count}})"
      },
      "userIdFallback": "User #{{id}}",
      "noEndDate": "(no end date)",
      "revokedOn": "Revoked {{date}}",
      "revokeTitle": "Revoke proxy access",
      "confirmRevokeTitle": "Revoke proxy access?",
      "confirmRevokeBody": "{{name}} will lose access to this patient's portal data immediately. The record stays in the audit trail.",
      "confirmRevokeLabel": "Revoke access"
    },
    "merge": {
      "title": "Patient Merge",
      "description": "Merge duplicate patient records. The source patient will be deactivated and all clinical data will be moved to the target (surviving) patient.",
      "sourceLabel": "Source Patient (will be deactivated)",
      "targetLabel": "Target Patient (surviving record)",
      "clearSelection": "Clear selection",
      "searchPlaceholder": "Search by name, MRN, or phone...",
      "fields": {
        "mrn": "MRN",
        "dob": "DOB",
        "gender": "Gender",
        "country": "Country",
        "phone": "Phone",
        "email": "Email"
      },
      "counts": {
        "encounters": "Encounters: {{count}}",
        "allergies": "Allergies: {{count}}",
        "problems": "Problems: {{count}}"
      },
      "samePatientWarning": "Source and target must be different patients.",
      "comparisonTitle": "Demographics Comparison",
      "comparisonSubtitle": "Differences are highlighted in amber.",
      "columns": {
        "field": "Field",
        "source": "Source ({{mrn}})",
        "target": "Target ({{mrn}})"
      },
      "comparisonLabels": {
        "fullName": "Full Name",
        "mrn": "MRN",
        "dateOfBirth": "Date of Birth",
        "gender": "Gender",
        "phone": "Phone",
        "email": "Email",
        "country": "Country",
        "nationalId": "National ID"
      },
      "reasonLabel": "Merge Reason",
      "reasonPlaceholder": "Reason for merging these records (required)",
      "notesLabel": "Notes (optional)",
      "notesPlaceholder": "Additional notes about this merge",
      "mergeButton": "Merge Patients",
      "mergeSuccess": "Patients merged successfully",
      "mergeError": "Failed to merge patients",
      "successHeading": "Merge completed successfully.",
      "successBodyPrefix": "Patient {{mrn}} has been deactivated. All clinical data has been moved to ",
      "successBodySuffix": ".",
      "confirmTitle": "Confirm Patient Merge",
      "confirmBodyPrefix": "This action ",
      "confirmBodyEmphasis": "CANNOT be undone",
      "confirmBodySuffix": ". Patient {{sourceMrn}} ({{sourceName}}) will be deactivated and all clinical data will be moved to Patient {{targetMrn}} ({{targetName}}).",
      "confirmButton": "Yes, Merge Patients"
    },
    "allergy": {
      "addTitle": "Add Allergy",
      "editTitle": "Edit Allergy",
      "allergen": "Allergen",
      "allergenPlaceholder": "e.g., Penicillin, Peanuts",
      "type": "Type",
      "typeOptions": {
        "drug": "Drug",
        "food": "Food",
        "environmental": "Environmental"
      },
      "severityLabel": "Severity",
      "severity": {
        "mild": "Mild",
        "moderate": "Moderate",
        "severe": "Severe",
        "lifeThreatening": "Life-Threatening"
      },
      "__review_severity": "APAC clinical severity grading varies — verify with local clinical reviewer before APAC pilot rollout",
      "reaction": "Reaction",
      "reactionPlaceholder": "e.g., Hives, Anaphylaxis, Nausea",
      "reactionOptions": {
        "rash": "Rash",
        "hives": "Hives",
        "anaphylaxis": "Anaphylaxis",
        "swelling": "Swelling",
        "itching": "Itching",
        "other": "Other"
      },
      "onsetDate": "Onset Date",
      "notes": "Notes",
      "notesPlaceholder": "Additional notes...",
      "verifiedBy": "Verified By",
      "noKnownAllergies": "No Known Allergies",
      "savedSuccess": "Allergy added successfully",
      "saveError": "Failed to add allergy",
      "deletedSuccess": "Allergy removed"
    },
    "banner": {
      "label": "Patient information",
      "vip": "VIP",
      "vipTitle": "VIP Patient",
      "mrn": "MRN",
      "dob": "DOB",
      "ageSuffix": "y",
      "sex": "Sex",
      "codeStatusAria": "Code status: {{status}}",
      "isolationAria": "Isolation: {{status}}",
      "isolation": {
        "contact": "Contact",
        "droplet": "Droplet",
        "airborne": "Airborne",
        "none": "None"
      },
      "__review_isolation": "Infection-control terminology may have facility-specific or jurisdictional preferences (e.g., 'enteric' for contact in some APAC settings) — verify with infection-control SMEs.",
      "fallRiskAria": "Fall risk: {{level}}",
      "fallRisk": {
        "label": "Fall Risk",
        "low": "Low",
        "moderate": "Moderate",
        "high": "High"
      },
      "interpreter": "Interpreter",
      "interpreterRequired": "Interpreter required — {{language}}",
      "languageNotSpecified": "language not specified",
      "weightKg": "{{weight}} kg",
      "allergiesLabel": "Allergies",
      "moreAllergies_one": "+{{count}} more",
      "moreAllergies_other": "+{{count}} more",
      "nkda": "NKDA"
    },
    "__review_banner": "Banner acronyms (MRN, DOB, NKDA, VIP, kg) stay verbatim across all locales — these are clinical/Latin-script conventions in APAC EMR practice.",
    "chartFrame": {
      "navAriaLabel": "Patient chart navigation",
      "tabs": {
        "summary": "Summary",
        "encounters": "Encounters",
        "orders": "Orders",
        "results": "Results",
        "medications": "Medications",
        "notes": "Notes",
        "problems": "Problems",
        "allergies": "Allergies",
        "immunizations": "Immunizations",
        "intakeOutput": "I/O",
        "carePlans": "Care Plans",
        "referrals": "Referrals",
        "familyHistory": "Family History",
        "socialHistory": "Social History",
        "surgicalHistory": "Surgical History",
        "advanceDirectives": "Advance Directives",
        "insurance": "Insurance",
        "contacts": "Contacts",
        "proxies": "Proxies",
        "identifiers": "Identifiers",
        "addresses": "Addresses"
      },
      "__review_tabs": "Tab labels span clinical, admin, and history modules — Tamil, Hindi, and zh-HK in particular should be reviewed for register and module-name fit. Pages for Notes/Results/Medications stay English until later phases; only the tab label is translated here.",
      "groups": {
        "clinical": "Clinical",
        "history": "History",
        "admin": "Admin"
      },
      "breakGlass": {
        "auditBanner": "BREAK-GLASS ACCESS — All activity is being audited. Access expires in 15 minutes.",
        "dialogTitle": "Restricted Patient Record",
        "dialogSubtitle": "Break-glass access required",
        "dialogBody": "This patient record is restricted. You must provide a justification to access it. All break-glass access is logged and audited.",
        "justificationLabel": "Justification",
        "justificationPlaceholder": "Enter clinical justification for accessing this restricted record...",
        "justificationRequired": "Justification is required for break-glass access.",
        "requestError": "Failed to request break-glass access. Please try again or contact an administrator.",
        "submitButton": "Access Record",
        "submitting": "Requesting..."
      },
      "invalidId": {
        "title": "Invalid Patient ID",
        "body": "The patient ID provided is not valid.",
        "action": "Search Patients"
      },
      "notFound": {
        "title": "Patient Not Found",
        "body": "Unable to load patient data. The patient may not exist or you may not have access.",
        "action": "Search Patients"
      }
    },
    "address": {
      "title": "Addresses",
      "addAddress": "Add Address",
      "newTitle": "New Address",
      "editTitle": "Edit Address",
      "loading": "Loading addresses...",
      "loadError": "Failed to load address information.",
      "empty": "No addresses on file.",
      "addressType": {
        "label": "Type",
        "values": {
          "home": "Home",
          "work": "Work",
          "temporary": "Temporary",
          "billing": "Billing"
        }
      },
      "fields": {
        "addressLine1": "Address Line 1",
        "addressLine2": "Address Line 2",
        "addressLine3": "Address Line 3",
        "district": "District",
        "city": "City",
        "stateProvince": "State / Province",
        "postalCode": "Postal Code",
        "country": "Country"
      },
      "placeholders": {
        "addressLine1": "Street address",
        "addressLine2": "Apt, unit, floor",
        "addressLine3": "Building, block",
        "district": "District / ward",
        "postalCode": "e.g. 123456",
        "country": "e.g. SG"
      },
      "primaryBadge": "Primary",
      "setPrimary": "Set as primary address",
      "primaryHelper": "(other addresses will be unset as primary)",
      "fromLabel": "From: {{date}}",
      "toLabel": "To: {{date}}",
      "save": "Save",
      "update": "Update",
      "cancel": "Cancel",
      "editTooltip": "Edit address",
      "removeTooltip": "Remove address",
      "addedSuccess": "Address added",
      "addError": "Failed to add address",
      "updatedSuccess": "Address updated",
      "updateError": "Failed to update address",
      "removedSuccess": "Address removed",
      "removeError": "Failed to remove address",
      "requiredError": "Address line 1 and country are required",
      "confirmRemoveTitle": "Remove Address",
      "confirmRemoveMessage": "Are you sure you want to remove this {{type}} address?",
      "confirmRemoveLabel": "Remove"
    },
    "allergies": {
      "pageTitle": "Allergies",
      "addAllergy": "Add Allergy",
      "loading": "Loading allergies...",
      "loadError": "Failed to load allergy information.",
      "nka": {
        "title": "No Known Allergies (NKA)",
        "body": "No allergies have been documented for this patient."
      },
      "sections": {
        "active": "Active Allergies ({{count}})",
        "inactive": "Inactive Allergies ({{count}})"
      },
      "fields": {
        "reaction": "Reaction",
        "severity": "Severity",
        "onset": "Onset",
        "recorded": "Recorded"
      },
      "inactiveSummary": "Reaction: {{reaction}} | Severity: {{severity}}",
      "deactivate": "Deactivate",
      "deactivateTooltip": "Deactivate allergy",
      "deleteTooltip": "Delete allergy",
      "deactivatedSuccess": "Allergy deactivated",
      "deactivateError": "Failed to deactivate allergy",
      "removedSuccess": "Allergy removed",
      "removeError": "Failed to remove allergy",
      "confirmDeactivateTitle": "Confirm Deactivation",
      "confirmDeactivateMessage": "Are you sure you want to deactivate \"{{name}}\"?",
      "confirmDeleteTitle": "Confirm Deletion",
      "confirmDeleteMessage": "Are you sure you want to permanently delete \"{{name}}\"?",
      "confirmLabel": "Confirm"
    },
    "problems": {
      "pageTitle": "Problem List",
      "addProblem": "Add Problem",
      "loading": "Loading problem list...",
      "loadError": "Failed to load problem list.",
      "tabs": {
        "active": "Active ({{count}})",
        "resolvedInactive": "Resolved / Inactive ({{count}})"
      },
      "sortByLabel": "Sort by:",
      "sortBy": {
        "onsetDate": "Onset Date",
        "severity": "Severity"
      },
      "status": {
        "label": "Status",
        "values": {
          "active": "Active",
          "resolved": "Resolved",
          "inactive": "Inactive"
        }
      },
      "empty": {
        "active": "No active problems recorded.",
        "resolved": "No resolved or inactive problems."
      },
      "fields": {
        "onset": "Onset",
        "resolved": "Resolved"
      },
      "resolveButton": "Resolve",
      "reactivateButton": "Reactivate",
      "resolveTooltip": "Mark as resolved",
      "reactivateTooltip": "Reactivate",
      "statusUpdatedSuccess": "Problem status updated",
      "statusUpdateError": "Failed to update problem status"
    },
    "immunizations": {
      "pageTitle": "Immunizations",
      "addImmunization": "Add Immunization",
      "loading": "Loading immunization records...",
      "loadError": "Failed to load immunization records.",
      "empty": "No immunization records found.",
      "dueOverdue": "Due / Overdue Immunizations ({{count}})",
      "upcoming": "Upcoming Immunizations ({{count}})",
      "dueLabel": "Due: {{date}}",
      "fromDateLabel": "From Date",
      "toDateLabel": "To Date",
      "fromDateAria": "Immunization date from",
      "toDateAria": "Immunization date to",
      "clearFilters": "Clear",
      "cvxLabel": "CVX: {{code}}",
      "columns": {
        "vaccine": "Vaccine",
        "date": "Date",
        "lotNumber": "Lot #",
        "site": "Site",
        "administeredBy": "Administered By",
        "nextDue": "Next Due",
        "status": "Status"
      },
      "dueStatus": {
        "label": "Status",
        "values": {
          "overdue": "Overdue",
          "dueToday": "Due Today",
          "upcoming": "Upcoming"
        }
      }
    },
    "contacts": {
      "pageTitle": "Contacts",
      "addContact": "Add Contact",
      "loading": "Loading contacts...",
      "loadError": "Failed to load contact information.",
      "empty": "No contacts on file.",
      "emergencyBadge": "Emergency",
      "sections": {
        "emergency": "Emergency Contacts ({{count}})",
        "other": "Other Contacts ({{count}})"
      },
      "editTooltip": "Edit contact",
      "deleteTooltip": "Delete contact",
      "deletedSuccess": "Contact deleted",
      "deleteError": "Failed to delete contact",
      "confirmDeleteTitle": "Delete Contact",
      "confirmDeleteMessage": "Are you sure you want to delete \"{{name}}\"?",
      "confirmDeleteLabel": "Delete"
    },
    "insurances": {
      "pageTitle": "Insurance",
      "addInsurance": "Add Insurance",
      "loading": "Loading insurance information...",
      "loadError": "Failed to load insurance information.",
      "empty": {
        "title": "No Insurance Plans",
        "body": "No insurance plans have been recorded for this patient."
      },
      "sections": {
        "active": "Active Plans ({{count}})",
        "inactive": "Inactive Plans ({{count}})"
      },
      "status": {
        "label": "Status",
        "values": {
          "active": "Active",
          "inactive": "Inactive",
          "pendingVerification": "Pending Verification"
        }
      },
      "fields": {
        "memberId": "Member ID",
        "groupNumber": "Group Number",
        "effectiveDate": "Effective Date",
        "terminationDate": "Termination Date",
        "copay": "Copay",
        "coinsurance": "Coinsurance",
        "deductible": "Deductible",
        "subscriber": "Subscriber"
      },
      "preAuthBadge": "Pre-authorization Required",
      "lastVerifiedLabel": "Last verified: {{date}}",
      "copayAmount": "${{amount}}",
      "coinsurancePercent": "{{percent}}%",
      "deductibleAmount": "${{amount}}",
      "verifyButton": "Verify",
      "verifyTooltip": "Verify eligibility",
      "editButton": "Edit",
      "verifySuccess": "Eligibility verification initiated",
      "verifyError": "Eligibility verification failed"
    },
    "identifiersTab": {
      "pageTitle": "Identifiers",
      "addIdentifier": "Add Identifier",
      "loading": "Loading identifiers...",
      "loadError": "Failed to load identifier information.",
      "empty": "No identifiers on file.",
      "newTitle": "New Identifier",
      "type": {
        "label": "Type",
        "selectPlaceholder": "Select type...",
        "values": {
          "externalMrn": "External MRN",
          "insuranceId": "Insurance ID",
          "studyId": "Study ID",
          "healthCard": "Health Card",
          "nationalRegistry": "National Registry",
          "passport": "Passport",
          "driverLicense": "Driver License",
          "other": "Other"
        }
      },
      "fields": {
        "value": "Value",
        "assigningAuthority": "Assigning Authority",
        "effectiveDate": "Effective Date",
        "expiryDate": "Expiry Date"
      },
      "placeholders": {
        "value": "e.g. S1234567D",
        "assigningAuthority": "e.g. MOH Singapore"
      },
      "status": {
        "label": "Status",
        "values": {
          "active": "Active",
          "inactive": "Inactive"
        }
      },
      "columns": {
        "type": "Type",
        "value": "Value",
        "assigningAuthority": "Assigning Authority",
        "effectiveDate": "Effective Date",
        "expiryDate": "Expiry Date",
        "status": "Status",
        "actions": "Actions"
      },
      "save": "Save",
      "cancel": "Cancel",
      "removeTooltip": "Remove identifier",
      "addedSuccess": "Identifier added",
      "addError": "Failed to add identifier",
      "removedSuccess": "Identifier removed",
      "removeError": "Failed to remove identifier",
      "requiredError": "Type and value are required",
      "confirmRemoveTitle": "Remove Identifier",
      "confirmRemoveMessage": "Are you sure you want to remove \"{{type}}: {{value}}\"?",
      "confirmRemoveLabel": "Remove"
    }
  },
  "portal": {},
  "results": {
    "review": "Results Review",
    "lab": "Lab Results",
    "imaging": "Imaging Results",
    "value": "Value",
    "unit": "Unit",
    "referenceRange": "Reference Range",
    "abnormal": "Abnormal",
    "critical": "Critical",
    "criticalValue": "Critical Value",
    "acknowledged": "Acknowledged",
    "pending": "Pending",
    "final": "Final",
    "reportDate": "Report Date",
    "interpretation": "Interpretation"
  },
  "scheduling": {
    "scheduling": "Appointment Scheduling",
    "date": "Date",
    "time": "Time",
    "duration": "Duration",
    "provider": "Provider",
    "reason": "Reason",
    "status": "Status",
    "statusOptions": {
      "scheduled": "Scheduled",
      "confirmed": "Confirmed",
      "checkedIn": "Checked In",
      "inProgress": "In Progress",
      "completed": "Completed",
      "cancelled": "Cancelled",
      "noShow": "No Show"
    }
  },
  "specimen": {
    "collect": "Collect Specimen",
    "track": "Track Specimen",
    "accession": "Accession Number",
    "barcode": "Barcode",
    "status": {
      "ordered": "Ordered",
      "collected": "Collected",
      "inTransit": "In Transit",
      "received": "Received",
      "processing": "Processing",
      "resulted": "Resulted"
    }
  },
  "flowsheets": {
    "vitalsEntry": {
      "title": "Vitals",
      "subtitle": "Record and review vital signs",
      "save": "Record Vitals",
      "cancel": "Cancel"
    },
    "vitals": {
      "systolic": "Systolic BP",
      "diastolic": "Diastolic BP",
      "heartRate": "Heart Rate",
      "respiratoryRate": "Respiratory Rate",
      "temperature": "Temperature",
      "oxygenSaturation": "Oxygen Saturation (SpO2)",
      "painScore": "Pain Score",
      "weight": "Weight",
      "height": "Height",
      "bmi": "BMI",
      "rangeError": "{{field}} must be between {{min}} and {{max}}"
    },
    "vitalsRange": {
      "normal": "Normal",
      "borderline": "Borderline",
      "abnormal": "Abnormal",
      "critical": "Critical"
    }
  },
  "smartphrases": {}
}
